import React from "react"
import { OnDemandAnalysis } from "../../../Types/AnalysisDetails"
import { useModalProvider } from "../../../../../../../Providers/ModalProvider"
import { MobergButton, MobergButtonVariant, MobergColumn, MobergHeader, MobergRow, MobergTheme } from "../../../../../../../Moberg"
import { Scrollbar } from "../../../../../../../Constants/StyledComponents"
import { getAnalysisEditor } from "./AnalysisEditorFactory"
import { useValidationProvider, ValidationProvider } from "../../../../../../../Providers/ValidationProvider"

type EditAnalsysisModalProps = {
	analysis: OnDemandAnalysis | undefined
	rawDataKey: string | undefined
	onChange: (analysis: OnDemandAnalysis | undefined) => void
}

export const EditAnalysisModal: React.FC<EditAnalsysisModalProps> = ({ analysis, rawDataKey, onChange }) => {
	return (
		<ValidationProvider>
			<EditAnalysisModalContent analysis={analysis} rawDataKey={rawDataKey} onChange={onChange} />
		</ValidationProvider>
	)
}

const EditAnalysisModalContent: React.FC<EditAnalsysisModalProps> = ({ analysis, rawDataKey, onChange }) => {
	const { close } = useModalProvider()
	const { firstError } = useValidationProvider()

	return (
		<MobergColumn gap="32px" style={{ width: "70vh", maxHeight: "95vh", minHeight: "500px", padding: "16px" }}>

			<MobergRow horizontalAlign="center">
				<MobergHeader>
					Edit Calculation
				</MobergHeader>

			</MobergRow>

			<Scrollbar style={{ flex: 1, padding: "0 16px" }}>
				{getAnalysisEditor(analysis, rawDataKey, onChange)}
			</Scrollbar>

			<MobergRow horizontalAlign="right">
				<MobergButton
					variant={MobergButtonVariant.FILLED}
					theme={MobergTheme.BLUE}
					onClick={close}
					disabled={!!firstError}
					tooltip={firstError}
				>
					OK
				</MobergButton>
			</MobergRow>

		</MobergColumn>
	)
}
